<!-- Dragscroll.js -->
! function(e, n) {
    "function" == typeof define && define.amd ? define(["exports"], n) : n("undefined" != typeof exports ? exports : e.dragscroll = {})
}(this, function(e) {
    var n, t, o = window,
        l = document,
        c = "mousemove",
        r = "mouseup",
        i = "mousedown",
        m = "EventListener",
        d = "add" + m,
        s = "remove" + m,
        f = [],
        u = function(e, m) {
            for (e = 0; e < f.length;) m = f[e++], m = m.container || m, m[s](i, m.md, 0), o[s](r, m.mu, 0), o[s](c, m.mm, 0);
            for (f = [].slice.call(l.getElementsByClassName("dragscroll")), e = 0; e < f.length;) ! function(e, m, s, f, u, a) {
                (a = e.container || e)[d](i, a.md = function(n) {
                    e.hasAttribute("nochilddrag") && l.elementFromPoint(n.pageX, n.pageY) != a || (f = 1, m = n.clientX, s = n.clientY, n.preventDefault())
                }, 0), o[d](r, a.mu = function() {
                    f = 0
                }, 0), o[d](c, a.mm = function(o) {
                    f && ((u = e.scroller || e).scrollLeft -= n = -m + (m = o.clientX), u.scrollTop -= t = -s + (s = o.clientY), e == l.body && ((u = l.documentElement).scrollLeft -= n, u.scrollTop -= t))
                }, 0)
            }(f[e++])
        };
    "complete" == l.readyState ? u() : o[d]("load", u, 0), e.reset = u
});


$(document).ready(function() {
    (function($) {

        $.fn.visible = function(partial) {

            var $t = $(this),
                $w = $(window),
                viewTop = $w.scrollTop(),
                viewBottom = viewTop + $w.height(),
                _top = $t.offset().top,
                _bottom = _top + $t.height(),
                compareTop = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

        };

    })(jQuery);

    $(window).scroll(function(event) {

        $(".home_product2").each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("image_animated");
            } else {
                el.removeClass("image_animated");
            }
        });

    });


    var translateY = 0;
    $(window).bind('mousewheel', function(e) {
        translateY += e.originalEvent.wheelDelta > 0 ? 2 : -2;
        $(".home_product2 .animation-image").stop().animate({
            translateY: translateY
        }, {
            step: function(now) {
                $(".image_animated .animation-image").css({
                    '-webkit-transform': 'translateY(' + now + 'px)',
                    '-moz-transform': 'translateY(' + now + 'px)',
                    'transform': 'translateY(' + now + 'px)'
                });
            }
        });
    });
    //header remove absolute class if having no banner
    var elength = jQuery('.featured-image-wrapper').length
    //console.log(elength);
    if (elength <= 0) {
        if (!jQuery('body').hasClass('index')) {
            jQuery('.header-wrapper').removeClass('absolute');
            jQuery('.header-section header').removeClass('absolute');
        }

    } else {
        $("#content").css("padding-top", "0");
        jQuery('#content').removeClass('row');
    }
    $('.has_sub_menu').click(function() {
        $(this).toggleClass('active');
    });
    jQuery('.product-thumbnail').hover(function() {
        jQuery(this).trigger('click');
    });


    jQuery('.details-button').click(function() {
        jQuery('.chart-inner').toggle();
        jQuery('.details-icon').toggleClass('rotate');
        jQuery('.text-content1').toggleClass('text-active');
        jQuery('.text-content').toggleClass('content-active');
    });


    //thumbnail image slider js
    $('.pro-slider').slick({
        dots: true,
        centerMode: true,
        centerPadding: '60px',
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1

    });
    $('.review-slider').slick({
        dots: false,
        centerMode: true,
        centerPadding: '60px',
        arrows: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplaySpeed: 7000,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });


    //thumbnail image slider js end
    jQuery('.custom-addtocart').click(function() {
        jQuery('.AddtoCart').trigger('click');

    });

    $('.product-gallery-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        centerMode: true

    });
    $(".mobile-trig-menu").trigger("click");
    jQuery('.sub,.add').click(function() {
        setTimeout(function() {
            jQuery('#update-cart').trigger('click')
        }, 100);
    });
    // product page js
    jQuery('.thumbnail-image').mouseover(function() {
        jQuery('.product-thumbnail').removeClass('selected');
    });

    // cart page button toggle js

    jQuery(document).on('click', '.details-trigger', function() {
        jQuery(this).toggleClass('detail_show');
        jQuery(this).parents('.cart-tem').find('#include-content').toggleClass('detail_show_trigger');
    });


    // cart page button toggle js end


    // mission page js

    jQuery('.ani_toggle_text').click(function() {
        //jQuery(this).parents('.step-info-modals').find('.modal').addClass('modal-active');
        jQuery('.step-info-modals').addClass('modal-active');
        jQuery('body').addClass('modal-popup');
        jQuery('.modal-backdrop').css('opacity', '0.65');
        jQuery('.modal').css('opacity', '1');
    });
    jQuery('.popup-close-btn').click(function() {
        jQuery('.step-info-modals').removeClass('modal-active');
        jQuery('body').removeClass('modal-popup');
    });
    jQuery('.ani_toggle_text2').click(function() {
        //jQuery(this).parents('.step-info-modals').find('.modal').addClass('modal-active');
        jQuery('.step-info-modals1').addClass('modal-active');
        jQuery('body').addClass('modal-popup');
        jQuery('.modal-backdrop').css('opacity', '0.65');
        jQuery('.modal').css('opacity', '1');
    });
    jQuery('.popup-close-btn').click(function() {
        jQuery('.step-info-modals1').removeClass('modal-active');
        jQuery('body').removeClass('modal-popup');
    });

    $(document).keydown(function(event) {
        if (event.keyCode == 27) {
            $.fancybox.close(true);
        }
    });

    // mission page Slider
    if ($(window).width() < 1080) {
        $('#mis-slide').slick({
            dots: true,
            infinite: true,
            arrows: false,
            prevArrow: false,
            nextArrow: false,
            slidesToShow: 1,
            slidesToScroll: 1

        });
    }


});




// size chart js

    $(document).ready(function() {
    jQuery('.switch-btn').on('click', function(e) {
        e.preventDefault();
        jQuery('.switch-btn').removeClass('active');
        var $btnelement = jQuery(this);
        jQuery($btnelement).addClass('active');
        if (jQuery($btnelement).hasClass('inches')) {
            jQuery('.chart .row.item .inches').show();
            jQuery('.chart .row.item .cm').hide();
            jQuery('.mobile-sizes .inches').show();
            jQuery('.mobile-sizes .cm').hide();

        }
        if (jQuery($btnelement).hasClass('centi')) {
            jQuery('.chart .row.item .inches').hide();
            jQuery('.chart .row.item .cm').show();
            jQuery('.mobile-sizes .inches').hide();
            jQuery('.mobile-sizes .cm').show();
        }

    });

    jQuery('.twin').addClass('active');
    jQuery('.col .mobile-tab').click(function() {
        jQuery('.col .mobile-tab').removeClass('selected');
        var $mobileelement = jQuery(this);
        jQuery($mobileelement).addClass('selected');
        if (jQuery('.tab-twin').hasClass('selected')) {
            jQuery('.twin').addClass('active');
            jQuery('.full').removeClass('active');
            jQuery('.queen').removeClass('active');
            jQuery('.king').removeClass('active');
        }
        if (jQuery('.tab-full').hasClass('selected')) {
            jQuery('.full').addClass('active');
            jQuery('.twin').removeClass('active');
            jQuery('.queen').removeClass('active');
            jQuery('.king').removeClass('active');
        }
        if (jQuery('.tab-queen').hasClass('selected')) {
            jQuery('.queen').addClass('active');
            jQuery('.twin').removeClass('active');
            jQuery('.full').removeClass('active');
            jQuery('.king').removeClass('active');
        }
        if (jQuery('.tab-king').hasClass('selected')) {
            jQuery('.king').addClass('active');
            jQuery('.twin').removeClass('active');
            jQuery('.queen').removeClass('active');
            jQuery('.full').removeClass('active');
        }

    });
    // faq toggle mobile view
    if (jQuery(window).width() < 958) {
        jQuery('.faq-block .toggle-button').click(function() {
            jQuery(this).parents('.faq-block').toggleClass('active-content');

        });

    }

    // instagram section mobile view home page
    if ($(window).width() < 980) {
        $('.insta-image-moblie').slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            prevArrow: false,
            nextArrow: false
        });
    }

    //header remove absolute class if having no banner
    var elength = jQuery('.featured-image-wrapper').length
    if (elength <= 0) {
        if (!jQuery('body').hasClass('index')) {

            jQuery('.header-wrapper').removeClass('absolute');
            jQuery('.header-section header').removeClass('absolute');
        } else

        {
            $("#content").css("padding-top", "0");
            jQuery('#content').removeClass('row');
        }

    }

    // based on color vaiants
    jQuery('.swatch-element.color ').click(function() {
        var count = 0;
        var selectedColor = jQuery(this).find('input').val();
        var subTitle = selectedColor.substr(0, selectedColor.indexOf(' '));
        var prdTitle = jQuery('.product-title').data('title');
        if (count == 0 && (jQuery('body').hasClass('sheet-set'))) {
            //jQuery('.product-title').text(subTitle+' '+prdTitle);
            count++;
        }
        var windowWidth = jQuery(window).width();

        if (windowWidth > 960) {
            //  Repositioning product thumbnails on PDP
            var thumbCount = jQuery('.product-thumbnail img[alt="' + selectedColor + '"]').length + jQuery('.product-thumbnail img[alt="all_variants"]').length;

            if (thumbCount == 1) {
                jQuery('.slick-track').removeClass('one-grid').removeClass('two-grid').removeClass('three-grid').removeClass('four-grid').removeClass('five-grid').addClass('one-grid');
            } else if (thumbCount == 2) {
                jQuery('.slick-track').removeClass('one-grid').removeClass('two-grid').removeClass('three-grid').removeClass('four-grid').removeClass('five-grid').addClass('two-grid');
            } else if (thumbCount == 3) {
                jQuery('.slick-track').removeClass('one-grid').removeClass('two-grid').removeClass('three-grid').removeClass('four-grid').removeClass('five-grid').addClass('three-grid');
            } else if (thumbCount == 4) {
                jQuery('.slick-track').removeClass('one-grid').removeClass('two-grid').removeClass('three-grid').removeClass('four-grid').removeClass('five-grid').addClass('four-grid');
            } else if (thumbCount >= 5) {
                jQuery('.slick-track').removeClass('one-grid').removeClass('two-grid').removeClass('three-grid').removeClass('four-grid').removeClass('five-grid').addClass('five-grid');
            }
            jQuery('.product-thumbnail img').each(function() {
                var ThumbnailColor = jQuery(this).attr('alt');
                if (selectedColor == ThumbnailColor || ThumbnailColor == "all_variants") {
                    jQuery(this).parents('.slick-slide').show();
                } else {
                    jQuery(this).parents('.slick-slide').hide();
                }
            });
            jQuery('.swatch-element.color ').removeClass('active')
            $(this).addClass('active');
            var colorName = jQuery('.swatch .Color').data('option');
            var selectedValue = jQuery(this).find('input').val();
            jQuery('h5.Color').text((colorName + ' : ' + selectedValue).replace("LE: ", ""));
        } else {
            jQuery('.product-image-container').css('opacity', 0);
            var mobileImageshtml = '';
            //       if(!jQuery().hasClass('slick-initialized'))
            //       {
            //       jQuery('.product-image-container').slick('unslick');
            //       }
            jQuery('.product-image-container').html('');
            jQuery('.product-thumbnail img').each(function() {
                var ThumbnailColor = jQuery(this).attr('alt');
                if (selectedColor == ThumbnailColor || ThumbnailColor == "all_variants") {
                    var ImageUrl = jQuery(this).data('imgsrc');
                    mobileImageshtml += '<img src="' + ImageUrl + '" />';
                }
            });
            setTimeout(function() {
                /*if (jQuery().hasClass('slick-initialized') == false) {
                    jQuery('.product-image-container').slick('unslick');
                }dmr*/
                jQuery('.product-image-container').html(mobileImageshtml);
                /*jQuery('.product-image-container').slick({
                    dots: true,
                    infinite: false,
                    arrows: true,
                    nextArrow: '<a class="slick-next slick-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50 L 70,10 L 60,0 Z" class="arrow"></path></svg></a>',
                    prevArrow: '<a class="slick-prev slick-arrow"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></a>',
                    slidesToShow: 1,
                    slidesToScroll: 1
                });*/
                jQuery('.product-image-container').css('opacity', 1);

            }, 10);

            var colorName = jQuery('.swatch .Color').data('option');
            var selectedValue = jQuery(this).find('input').val();
            jQuery('h5.Color').text((colorName + ' : ' + selectedValue).replace("LE: ", ""));
        }
    });
    //  based on style variants
    jQuery('.swatch-element.Style ').click(function() {
        var count = 0;
        var selectedStyle = jQuery(this).find('input').val();
        var prdTitle = jQuery('.product-title').data('title');
        if (jQuery('body').hasClass('the-foundation-set')) {
            jQuery('.product-title').text(prdTitle + ' ' + selectedStyle);
            count++;
        }
        jQuery('.swatch-element.Style ').removeClass('active')
        $(this).addClass('active');
        var colorName = jQuery('.swatch .Style').data('option');
        var selectedValue = jQuery(this).find('input').val();
        jQuery('h5.Style').text(colorName + ' : ' + selectedValue);
    });

    //  based on size variants
    jQuery('.swatch-element.Size').click(function() {
        jQuery('.swatch-element.Size ').removeClass('active')
        $(this).addClass('active');
        var colorName = jQuery('.swatch .Size').data('option');
        var selectedValue = jQuery(this).find('input').val();
        jQuery('h5.Size').text(colorName + ' : ' + selectedValue);
    });

    //  default variants selected start  
    jQuery('.swatch-element.color').each(function() {
        if (jQuery(this).find('input').prop('checked')) {
            jQuery(this).find('input').click();
        }

    });

    jQuery('.swatch-element.Size').each(function() {
        if (jQuery(this).find('input').prop('checked')) {
            jQuery(this).find('input').click();
        }
    });

    //  product faq start

    //toggle the component with class accordion_body
    $(".accordion_head").click(function() {
        $(this).removeClass('coll-back');
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            //$(".plusminus").text('+');
            $(this).removeClass('coll-back');
            $('.rmv-cls').removeClass('coll-back');
        }

        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            //$(this).children(".plusminus").text('+');
            $(this).removeClass('coll-back');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('');
            // $(this).children(".plusminus").append('<hr class="hr-clc">');
            $(this).toggleClass('coll-back');
            $(this).addClass('rmv-cls');
        }
    });
    //  product review end

});


//   end document.ready



$(document).ready(function() {

    if ($(window).width() < 767) {
        $('.product-page-main-mobile.product-page-main').removeClass('product-page-main');
    } else {
        $('.product-page-main-mobile').addClass('product-page-main');
    }


    // product page gallery slider
    $('.modal-toggle').on('click', function(e) {
        e.preventDefault();
        $('.model').toggleClass('is-visible');
        $('body').toggleClass('modal-popup');

    });
    $(document).keydown(function(event) {
        if (event.keyCode == 27) {
            $.fancybox.close(true);
        }
    });

    //   if ($('.coupan-code')[0]) {
    //    $('html').addClass("fancybox-lock");
    //    } 
});
setInterval(function() {

    if ($('.fancybox-opened').length > 0) {
        // console.log('fancybox'+ $('.fancybox-opened').length);
        $('html').addClass("fancybox-lock");
        $('body').addClass("popup-overlay-code");
    } else {
        //console.log('fancybox close'+ $('.fancybox-opened').length);
        $('html').removeClass("fancybox-lock");

        $('body').removeClass("popup-overlay-code");
    }
}, 500);


// Product FAQs

$(document).ready(function() {

    $('.faq-icon img').click(function() {
        $(this).toggleClass('active').parents().parents().siblings().children().children('img').removeClass('active');
        $(this).parents().siblings('p').toggleClass('active').parents().siblings().children('p').removeClass('active');
    });

    $('.each-question h3').click(function() {
        $(this).siblings().children('img').toggleClass('active').parents().parents().siblings().children().children('img').removeClass('active');
        $(this).siblings('p').toggleClass('active').parents().siblings().children('p').removeClass('active');
    });

});

function hideAddonsInCart(){
    $('.mc-addon-initial').each(function(){
        $(this).parent().show();
    });
    var cart_items = CartJS.cart.items;
    for(var i=0; i<cart_items.length; i++){
        $('.mc-addon-initial.'+CartJS.cart.items[i].handle).parent().hide();
    }
}

function update_pieces(){
    var size = $('input[name=size]:checked').attr('value');

    var pcaseno = "2 pillowcases.";
    var fs_no = "1 fitted sheet";
    if(size == "Twin (XL)"){
        pcaseno = "1 pillowcase.";
    } else if(size == "Split King") {
        fs_no = "2 fitted sheets";
    }

    $('span.fs-no').html(fs_no);
    $('span.pcaseno').html(pcaseno);
}

function toggle_gdpr(){

    if($('#cookie-consent-dialogBox').length == 1){

    fetch('https://ipapi.co/json/')
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if(data.region == "California"){
            $('#cookie-consent-dialogBox').show();
        } else if(data.currency_name == "Euro"){
            $('#cookie-consent-dialogBox').show();
        } else {
            $('#cookie-consent-dialogBox').hide();
        }
      });
    } else {
        setTimeout(function(){ toggle_gdpr(); }, 2000);
    }
}

function fixReviews(){
    if ($('.wc_review_count').length == 0) {
        setTimeout(function() {
            fixReviews();
        }, 100);
    } else {

        $('.desktop .wc_product_review_title').hide();
        $('.wc_review_badge_inner').each(function(){ $(this).css('padding',0); });
        $('.wc_icon_color svg').each(function(){ $(this).attr('width', '16px'); });
        $('.wc_icon_color svg').each(function(){ $(this).attr('height', '16px'); });
        $('.wc_icon_color').each(function(){ $(this).css('margin-right','0'); });
        $('.desktop .wc_review_badge_inner').each(function(){ $(this).css('text-align', 'right'); });

        $('.wc_review_form_btns ul li:first').hide();
        $('.wc_review_top_title.wc_wf_cls').hide();

        $('.new-info-layout .ratings').css('visibility', 'visible');
        $('.wc_product_review_badge').css('visibility', 'visible');

    }
}
function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

(function($) {  
  $.fn.countTo = function(options) {    
    return this.each(function() {   
      //-- Arrange  
      var FRAME_RATE = 60; // Predefine default frame rate to be 60fps  
      var $el = $(this);    
      var countFrom = parseInt($el.attr('data-count-from'));    
      var countTo = parseInt($el.attr('data-count-to'));    
      var countSpeed = $el.attr('data-count-speed'); // Number increment per second 
      //-- Action   
      var rafId;    
      var increment;    
      var currentCount = countFrom; 
      var countAction = function() {              // Self looping local function via requestAnimationFrame  
        if(currentCount < countTo) {              // Perform number incremeant  
          $el.text(formatNumber(Math.floor(currentCount)));     // Update HTML display  
          increment = countSpeed / FRAME_RATE;    // Calculate increment step   
          currentCount += increment;              // Increment counter  
          rafId = requestAnimationFrame(countAction);   
        } else {                                  // Terminate animation once it reaches the target count number    
          $el.text(formatNumber(countTo));                      // Set to the final value before everything stops   
          //cancelAnimationFrame(rafId);    
        }   
      };    
      rafId = requestAnimationFrame(countAction); // Initiates the looping function 
    }); 
  };    
}(jQuery)); 


$(document).ready(function() {

    toggle_gdpr();

    //if (window.location.href.split('/')[3] == "pages" || window.location.href == "/") {
    //    fixKlaviyo();
    //}

    //on all product pages
    if (window.location.href.split('/')[3] == "products") {
        
        fixReviews();

        $('.mobile-accordion .toggle').click(function(e) {
            e.preventDefault();

            $('.mobile-accordion .toggle').each(function(){
                $(this).removeClass('active-toggle');
            });
          
            var $this = $(this);
            $(this).addClass('active-toggle');
          
            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(200);
                $(this).removeClass('active-toggle');
            } else {
                $this.parent().parent().find('li .inner').removeClass('show');
                $this.parent().parent().find('li .inner').slideUp(200);
                $this.next().toggleClass('show');
                $this.next().slideToggle(200);
            }
        });


        $('div.swatch-element').click(function(){
            update_pieces();
        });


        //product page scroll to top - dmr
        var btn = $('#a-product-top');


        $(".review-scroll").click(function() {
            $('html, body').animate({
                scrollTop: $(".okeReviews-widget-holder").offset().top - 60
            }, 300);
        });



        $(window).scroll(function() {
            if ($(window).scrollTop() > 300) {
                btn.addClass('show');
            } else {
                btn.removeClass('show');
            }
        });

        btn.on('click', function(e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, '300');
        });
    }

    //if index page & impact components 
    if($('section.impact-components').length == 1){ 
        $('.impact-figure').countTo();  
    }

    $(document).on('cart.ready', function(event, cart) {

        $('body').on('DOMSubtreeModified', '#total-value', function(){
           if(isFunction(affirm.ui.refresh) && CartJS.cart.item_count > 0){
                
                $('.affirm-as-low-as').each(function(){ 
                    if(parseInt($(this).attr('data-amount')) < 5000){
                        $('.mini-cart-subtotal .affirm-as-low-as').attr('data-amount', '5000');
                    }
                });
                affirm.ui.refresh();
            }
            hideAddonsInCart();
        });

    });


});

function fixKlaviyo(){

    if ($('.klaviyo-form').length == 0) {
        setTimeout(function() {
            fixKlaviyo();
        }, 100);
    } else {

        $('.klaviyo-form span').each(function(){
            $(this).css('font-family','"avertastd-regular"');
        });

        $('.klaviyo-form strong').each(function(){
            $(this).css('font-family','"avertastd-regular"');
        });

        $('.klaviyo-form button').each(function(){
            $(this).css('font-family','"avertastd-regular"');
        });

        $('body').on('DOMSubtreeModified', '.klaviyo-form', function(){
            $('.klaviyo-form span').each(function(){
                $(this).css('font-family','"avertastd-regular"');
            });

            $('.klaviyo-form strong').each(function(){
                $(this).css('font-family','"avertastd-regular"');
            });

            $('.klaviyo-form button').each(function(){
                $(this).css('font-family','"avertastd-regular"');
            });
        });
    }
}

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

$(document).on('cart.requestComplete', function(event, cart) {
    hideAddonsInCart();
});

$(document).on('cart.ready', function(event, cart) {
    $('.price-row').show();
    if(affirm.ui !== null){
        if(CartJS.cart.items_subtotal_price < 5000){
            $('.mini-cart-subtotal .affirm-as-low-as').attr('data-amount', '5000');
        }
        if(isFunction(affirm.ui.refresh)){
            affirm.ui.refresh();
        }
    }
    if(CartJS.cart.currency != "USD"){
        $('.affirm-as-low-as').hide();
        $('<span> '+CartJS.cart.currency+'</span>').insertBefore('.affirm-as-low-as');
        } else {
        $('.affirm-as-low-as').show();
    }
    hideAddonsInCart();
});